import Head from "assets/icons/Head.svg";
import {Card, Link, Stack, Typography} from "@mui/material";
import {contactDetails} from "../constants";

const ContactCard = () => {
  return (
    <Card
      sx={(theme) => ({
        borderRadius: 5,
        backgroundRepeat: 'no-repeat',
        boxShadow: 'none',
        [theme.breakpoints.up('xxs')]: {
          p: 2.5,
          backgroundImage: `url(${Head})`,
          backgroundPosition: 'calc(100% + 20px) calc(100% + 10px)',
        },
        [theme.breakpoints.up('xs')]: {
          backgroundPosition: 'bottom right',
        },
        [theme.breakpoints.up('md')]: {
          p: 3,
          backgroundPosition: 'calc(100% - 30px) calc(100% - 20px)',
        },
        [theme.breakpoints.up('lg')]: {
          pr: 25,
          backgroundPosition: 'calc(100% - 30px) center',
        },
        [theme.breakpoints.up('xl')]: {
          pr: 3,
          backgroundPosition: 'calc(100% - 30px) calc(100% - 20px)',
          width: 420
        },
      })}
    >
      <Stack spacing={2.5}>
        <Typography variant="h5">Служба заботы</Typography>
        <Stack spacing={2} direction={{xxs: 'column', lg: 'row', xl: 'column'}} justifyContent={{lg: 'space-between', xl: 'flex-start'}}>
          {contactDetails.map((detail, index) => (
            <Stack key={index} alignItems={'flex-start'}>
              <Typography variant="p3" sx={{color: 'grey.200'}}>
                {detail.description}
              </Typography>
              <Typography
                component={Link}
                href={detail.href}
                variant="h6"
                sx={{color: detail.color, textDecoration: 'none'}}
              >
                {detail.text}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Card>
  )
}

export default ContactCard
